import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {Formik, Field, FormikProps} from 'formik';

import {Layouts, Form, Button, Modal} from '@components';
import validate from '@validations';
import paths from '@paths';
import {Props} from './types';
import * as handlers from './handlers';

import './index.scss';

const Main: React.FC<Props> = props => {
  const initialValues = {email: ''};
  const [isModal, setIsModal] = useState(false);

  return (
    <div className="a__reset-password">
      <Layouts.Header.Before
        history={props.history}
        match={props.match}
        location={props.location}
      />
      <div className="w__field">
        <div className="b__title">パスワードリセット</div>
        <div className="b__message">
          メールアドレス宛にパスワードリセットの為の認証コードを送信します。
          <br />
          メールアドレスを入力してください。
          <br />
          パスワードリセットの必要が無ければ
          <Link to={paths.signIn.main} className="b__sign-in">
            ログイン
          </Link>
          してください。
          <div className="w__form">
            <Formik
              initialValues={initialValues}
              onSubmit={async (value, formikAction) =>
                await handlers.sendResetMail(
                  value,
                  formikAction,
                  props,
                  setIsModal
                )
              }
              validate={validate.users.resetPasswordMain}
            >
              {(formProps: FormikProps<any>) => {
                return (
                  <>
                    <Field
                      component={Form.Input}
                      name="email"
                      placeholder="メールアドレス"
                    />
                    <Button.Normal
                      color="yellow"
                      text="メールを送信する"
                      className="b__button"
                      rounded
                      loading={formProps.isSubmitting}
                      disabled={formProps.isSubmitting}
                      onClick={() => {
                        formProps.handleSubmit();
                      }}
                    />
                  </>
                );
              }}
            </Formik>
          </div>
        </div>
      </div>
      <Modal.Normal
        isModal={isModal}
        handleCloseModal={setIsModal}
        title="初期パスワードをお忘れですか？"
        size="sm"
        cancelText="閉じる"
      >
        <div>
          初期パスワードをお忘れの場合、特権管理者もしくは別の管理者に連絡して管理者の再登録を依頼してください。
          <br />
          再登録に関しては<Link to={paths.questions.main}>よくある質問</Link>
          をご確認ください。
        </div>
      </Modal.Normal>
      <Layouts.Footer.Main />
    </div>
  );
};

export default Main;
